import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { PuntoVisita } from '../Models/PuntoVisita';
import { PuntoVisitaLocalizacion } from '../Models/PuntoVisitaLocalizacion';
import { ReportePuntoVisitaCertificadoDistancia } from '../Models/ReportePuntoVisitaCertificadoDistancia';
@Injectable()
export class PuntoVisitaService {


  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Obtiene todos los puntos de visita por compañia
   * @param compania codigo de la compañia
   */
  ObtenerPuntoVisitas(compania: string): Observable<PuntoVisita[]> {

    try {

      let url = this._utiles.getURL("puntoVisita/" + compania);

      return this._http.get(url).map((response: Response) => {
        return <PuntoVisita[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtiene un punto de visita espesifico
   * @param compania codigo de la compañia
   * @param idPunto codigo del punto de visita
   */
  ObtenerPuntoVisita(compania: string, idPunto: string): Observable<PuntoVisita> {

    try {

      let url = this._utiles.getURL("puntoVisita/" + compania + '/' + idPunto);

      return this._http.get(url).map((response: Response) => {
        return <PuntoVisita>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Guarda el registro del punto de visita
   * @param puntoVisita clase de tipo "PuntoVisita"
   */
  public GuardarRegistro(puntoVisita: PuntoVisita) {

    try {

      let params = JSON.stringify(puntoVisita);

      let url = this._utiles.getURL("puntoVisita/");

      let headers = new Headers({ 'Content-Type': 'application/json' });

      let data: any;


      return this._http.post(url, puntoVisita, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }


  /**
   * Obtiene los puntos de visita otorgados por los choferes para actualizar
   * @param compania codigo de la compañia
   */
  ObtenerPuntoVisitasLocalizacion(compania: string): Observable<PuntoVisitaLocalizacion[]> {

    try {

      let url = this._utiles.getURL("puntoVisita/localizacionestadoactivo/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <PuntoVisitaLocalizacion[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Actualiza el punto de visita actual por el que dio el chofer
   * y le da un estado de que fue actualizado
   * @param idLocalidad codigo del punto de visita
   */
  ActualializarPuntoVisitaLocalidad(idLocalidad: number) {

    try {

      let url = this._utiles.getURL("puntoVisita/actualizarpuntovisitalocalidad/" + idLocalidad);

      return this._http.get(url).map((response: Response) => {
        return <PuntoVisitaLocalizacion[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Pone la peticion de actualizar el punto de visita dada por el chofer por denegada
   * @param idLocalidad Codigo del punto de visita
   */
  DenegarPuntoVisitaLocalidad(idLocalidad: number) {

    try {

      let url = this._utiles.getURL("puntoVisita/denegarpuntovisitalocalidad/" + idLocalidad);

      return this._http.get(url).map((response: Response) => {
        return <PuntoVisitaLocalizacion[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtiene un contador de los puntos de visita de los punto de visita dados por el chofer para que el administrador 
   * tenga conciente de esos punto de visita a actualizar
   * @param compania Codigo de la compañia
   */
  ObtenerContadorPuntoVisitaLocalizacion(compania: string): Observable<string> {

    try {

      let url = this._utiles.getURL("puntoVisita/contadorlocalizaciones/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <string>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Obtiene los puntos de visita para el reporte de puntos de visita por distancia
   * @param compania Codigo de la compañia
   */
  ObtenerReportePuntoVisitaDistanciaCertificacion(compania: string): Observable<ReportePuntoVisitaCertificadoDistancia[]> {

    try {

      let url = this._utiles.getURL("puntoVisita/reportepuntovistaDistancia/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <ReportePuntoVisitaCertificadoDistancia[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Actualiza el punto visita viejo por el de certificacion
   * @param idCompania Codigo de la compañia
   * @param idPunto Codigo del punto de visita
   * @param longitud longitid a actualizar
   * @param latitud latitid a actualizar
   */
  ActualizarPuntoVisitaDistanciaCertificacion(idCompania: string, idPunto: string, longitud: string, latitud: string) {

    try {

      let url = this._utiles.getURL("puntoVisita/puntovistadistanciacertificacion/" + idCompania + "/" + idPunto + "/" + longitud + "/" + latitud);


      return this._http.get(url).map((response: Response) => {
        return <ReportePuntoVisitaCertificadoDistancia[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

 RechazarPuntoVisitaDistanciaCertificacion(idCompania: string, idPunto: string) {

    try {

      let url = this._utiles.getURL("puntoVisita/puntovistadistanciacertificacionRechazo/" + idCompania + "/" + idPunto);


      return this._http.get(url).map((response: Response) => {
        return <ReportePuntoVisitaCertificadoDistancia[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


}
